import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/events/awaiting-approval')({
  beforeLoad: () => {
    throw redirect({
      to: '/events',
      search: { queue: 'needsApproval', view: 'list' },
      replace: true,
    });
  },
});
